// components/IdleHandler.tsx
import { useNavigate } from "react-router-dom";
import { toast } from "react-toastify";
import useIdleTimer from "../../hooks/useIdleTimer";
import { removeLocalState } from "../../utils/localStorage";
import { LOGIN } from "../../utils/navigation";
export default function IdleHandler() {
  const navigate = useNavigate();
  useIdleTimer({
    onIdle: () => {
      // Check again before logout
      const token = localStorage.getItem("access_token");
      if (token) {
        toast.warn("Vous avez été déconnecté après 2 heures d’inactivité.");
        removeLocalState("refresh_token");
        removeLocalState("_currentUser");
        removeLocalState("access_token");
        removeLocalState("client_d");
        navigate(LOGIN);
      }
    }
  });

  return null;
}
